"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.SubheadingWrapper = exports.PdfIcon = exports.LinearProgress = exports.HTMLImg = exports.IconWrapper = exports.ErrorTypography = exports.PlayIcon = exports.Image = exports.AttachmentIcon = exports.ContainerGrid = exports.ContainerBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _InsertDriveFileOutlined = _interopRequireDefault(require("@material-ui/icons/InsertDriveFileOutlined"));

var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _constants = require("./constants");

var _Typography = _interopRequireDefault(require("../Typography"));

var _Image = _interopRequireDefault(require("../Image"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

var _Pdf = _interopRequireDefault(require("../../theme/icons/Pdf"));

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin-right: ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    width: 100px;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 100%;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n    width: 24px;\n    height: 24px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 8px;\n  cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            padding: calc(", " * 1.5);\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            padding: ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n    padding: 0 0 0 ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ContainerBox = (0, _styledComponents["default"])(_Box["default"])(_templateObject(), _colors["default"].lychee[100], _colors["default"].lychee[600], _spacing["default"][1]);
exports.ContainerBox = ContainerBox;
var ContainerGrid = (0, _styledComponents["default"])(_Grid["default"])(_templateObject2(), function (props) {
  return props.size === _constants.MESSAGE_MEDIA_ATTACHMENT_SIZE.SMALL ? (0, _styledComponents.css)(_templateObject3(), _spacing["default"].small) : (0, _styledComponents.css)(_templateObject4(), _spacing["default"][1]);
});
exports.ContainerGrid = ContainerGrid;
var AttachmentIcon = (0, _styledComponents["default"])(_InsertDriveFileOutlined["default"])(_templateObject5(), _colors["default"].blackberry[400]);
exports.AttachmentIcon = AttachmentIcon;
var Image = (0, _styledComponents["default"])(_Image["default"])(_templateObject6());
exports.Image = Image;
var PlayIcon = (0, _styledComponents["default"])(_PlayArrow["default"])(_templateObject7(), _colors["default"].lychee[100]);
exports.PlayIcon = PlayIcon;
var ErrorTypography = (0, _styledComponents["default"])(_Typography["default"])(_templateObject8(), _colors["default"].strawberry[400]);
exports.ErrorTypography = ErrorTypography;
var IconWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject9(), _colors["default"].blackberry[400]);
exports.IconWrapper = IconWrapper;

var HTMLImg = _styledComponents["default"].img(_templateObject10());

exports.HTMLImg = HTMLImg;
var LinearProgress = (0, _styledComponents["default"])(_LinearProgress["default"])(_templateObject11());
exports.LinearProgress = LinearProgress;
var PdfIcon = (0, _styledComponents["default"])(_Pdf["default"])(_templateObject12(), _colors["default"].strawberry[400]);
exports.PdfIcon = PdfIcon;
var SubheadingWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject13(), _colors["default"].plum[500]);
exports.SubheadingWrapper = SubheadingWrapper;
var TextWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject14(), _spacing["default"][2]);
exports.TextWrapper = TextWrapper;